import fetch from "auth/FetchInterceptor";

const InternshipsService = {};

const InternshipEndpointPrefix = "/stage";

InternshipsService.getInternships = async () =>
    await fetch(`${InternshipEndpointPrefix}/getAll`, {
        method: "GET",
    });

InternshipsService.getInternshipById = async (internshipId) =>
    await fetch(`${InternshipEndpointPrefix}/getById/${internshipId}`, {
        method: "GET",
    });

InternshipsService.createInternship = async (data) =>
    await fetch({
        url: `${InternshipEndpointPrefix}/create`,
        method: "POST",
        data,
    });

InternshipsService.updateInternship = async (internshipId, data) =>
    await fetch(`${InternshipEndpointPrefix}/update/${internshipId}`, {
        method: "PUT",
        data,
    });

InternshipsService.deleteInternshipById = async (internshipId) =>
    await fetch(`${InternshipEndpointPrefix}/deleteById/${internshipId}`, {
        method: "DELETE",
    });

InternshipsService.addStudentToInternship = async (internshipId, studentId) =>
    await fetch(`${InternshipEndpointPrefix}/${internshipId}/addStudent`, {
        method: "PUT",
        data: {
            studentId,
        },
    });

InternshipsService.removeStudentFromInternship = async (
    internshipId,
    studentId
) =>
    await fetch(`${InternshipEndpointPrefix}/${internshipId}/deleteStudent`, {
        method: "DELETE",
        data: {
            studentStageId: studentId,
        },
    });

InternshipsService.getStudentsByInternshipId = async (internshipId) =>
    await fetch(`${InternshipEndpointPrefix}/${internshipId}/getAllStudents`, {
        method: "GET",
    });

export default InternshipsService;
